import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useFlag } from "../../config/featureFlags";

import { AuthContext, LocationContext } from "../../contexts";
import authServices from "../../services/auth/auth.service";
import { recordAnalyticsEvent } from "../../analytics";
import { UserNotFoundError } from "../../services/auth/auth.errors";
import { CircularProgress } from "../../components/util";
import LoginErr from "../../components/content/maintenance/login";
import { Role } from "../../types/user.type";
import { urls } from "../../config/appConfig";

const AuthorizeLogin = () => {
  const history = useHistory();
  const auth = useContext(AuthContext);
  const redirect = useFlag("portal.scheme_redirect");
  const { urlParams } = useContext(LocationContext);

  let code: string = urlParams?.code || "";
  let state: string = urlParams?.state || "";

  const [isError, setError] = useState<boolean>(false);

  useEffect(() => {
    const verifyLogin = async () => {
      const currentSession = await authServices.verify(code, state);
      try {
        const user = await authServices.getMittiUser();
        auth.updateUser(user);
      } catch (error: any) {
        if (error instanceof UserNotFoundError && currentSession) {
          const searchParams = new URLSearchParams(urlParams);
          searchParams.set("userAlreadyExistsInSC", "true");
          history.replace(`/link-sc-user-to-care?${searchParams.toString()}`);
        } else if (error instanceof UserNotFoundError && !currentSession) {
          window.location.replace(urls.careHome);
        } else {
          throw error;
        }
      }
    };

    /**
     * This condition is needed to prevent it from running verifyLogin after verification
     * */
    if (!auth.user) {
      verifyLogin().catch(_error => {
        setError(true);
      });
    } else {
      recordAnalyticsEvent("identify", "Logged In", auth.user);

      recordAnalyticsEvent("action", "Logged In", {
        type: auth.user?.type,
      });

      if (
        redirect &&
        auth.user?.organisations.length > 0 &&
        auth.user?.roles &&
        auth.user?.roles.includes(Role.Customer)
      ) {
        window.location.assign(urls.iauditorLink);
      } else {
        history.replace("/");
      }
    }
  }, [auth, auth.user, code, history, state, redirect, urlParams]);

  return !isError ? (
    <CircularProgress />
  ) : (
    <LoginErr auto_redirect_to_login={true} />
  );
};

export default AuthorizeLogin;
